module.exports = __webpack_public_path__ + "img/118M.4403e34f.png";